const STORAGE_PREFIX = 'memberNest.pwaClubNavigation.v1.lastClubId';
const TEAMS_ROOT = '/teams';
const TEAM_ROUTE_EXCLUSIONS = new Set(['search']);

function getStorage() {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage || null;
  } catch (err) {
    return null;
  }
}

function normalizeId(value) {
  return String(value || '').trim();
}

function safeDecodePathSegment(value) {
  try {
    return decodeURIComponent(value);
  } catch (err) {
    return value;
  }
}

export function getPwaClubNavigationStorageKey(userId) {
  const normalizedUserId = normalizeId(userId);
  if (!normalizedUserId) return '';
  return `${STORAGE_PREFIX}:${encodeURIComponent(normalizedUserId)}`;
}

export function getPwaClubIdFromPathname(pathname = '') {
  const [rawPath] = String(pathname || '').split(/[?#]/);
  const parts = rawPath.split('/').filter(Boolean);
  if (parts[0] !== 'teams') return '';
  const teamIdSegment = normalizeId(parts[1]);
  if (!teamIdSegment || TEAM_ROUTE_EXCLUSIONS.has(teamIdSegment)) return '';
  return safeDecodePathSegment(teamIdSegment);
}

export function getNextPwaSelectedClubId(pathname = '', selectedClubId = '') {
  return getPwaClubIdFromPathname(pathname) || normalizeId(selectedClubId);
}

export function getPwaClubsNavTarget(pathname = '', selectedClubId = '') {
  const currentClubId = getPwaClubIdFromPathname(pathname);
  const effectiveSelectedClubId = currentClubId || normalizeId(selectedClubId);
  if (!effectiveSelectedClubId) return TEAMS_ROOT;
  if (currentClubId && currentClubId === effectiveSelectedClubId) return TEAMS_ROOT;
  return `${TEAMS_ROOT}/${encodeURIComponent(effectiveSelectedClubId)}`;
}

export function getStoredPwaClubsNavTarget(pathname = '', userId = '', selectedClubId = '') {
  return getPwaClubsNavTarget(pathname, normalizeId(selectedClubId) || readLastPwaClubId(userId));
}

export function readLastPwaClubId(userId) {
  const key = getPwaClubNavigationStorageKey(userId);
  const storage = key ? getStorage() : null;
  if (!storage) return '';
  try {
    return normalizeId(storage.getItem(key));
  } catch (err) {
    return '';
  }
}

export function writeLastPwaClubId(userId, clubId) {
  const key = getPwaClubNavigationStorageKey(userId);
  const normalizedClubId = normalizeId(clubId);
  const storage = key && normalizedClubId ? getStorage() : null;
  if (!storage) return;
  try {
    storage.setItem(key, normalizedClubId);
  } catch (err) {}
}
